import { StepPage, StepRenderProps } from 'containers/StepPage/StepPage';
import { useCallback } from 'react';
import { SiteAnnouncementSetupFlowPageModel } from './SiteAnnouncementSetupFlowPageModel';
import { SiteAnnouncementForm } from './SiteAnnouncementForm';
import { Redirect } from 'react-router-dom';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { SiteAnnouncementSummary } from './SiteAnnouncementSummary';

export type SiteAnnouncementSetupFlowPageProps = {
  useModel: () => SiteAnnouncementSetupFlowPageModel;
};

export const SiteAnnouncementSetupFlowPage: React.FC<
  SiteAnnouncementSetupFlowPageProps
> = ({ useModel }) => {
  const {
    loading,
    title,
    redirectPath,
    siteAnnouncement,
    allAgencyOptions,
    isPublished,
    onSubmit,
    onCancel,
    validateForm,
    getFormConfig,
    setSiteAnnouncement
  } = useModel();

  const renderSetupStep = useCallback(
    ({ goNext }: StepRenderProps) => {
      return (
        <SiteAnnouncementForm
          siteAnnouncement={siteAnnouncement}
          goNext={goNext}
          onCancel={onCancel}
          validateForm={validateForm}
          getFormConfig={getFormConfig}
          setSiteAnnouncement={setSiteAnnouncement}
        />
      );
    },
    [
      siteAnnouncement,
      validateForm,
      getFormConfig,
      setSiteAnnouncement,
      onCancel
    ]
  );

  const renderSummaryStep = useCallback(
    ({ goLast }: StepRenderProps) => {
      if (!siteAnnouncement) {
        return <LoadingIndicator />;
      }
      return (
        <div>
          <SiteAnnouncementSummary
            siteAnnouncement={siteAnnouncement}
            agencyOptions={allAgencyOptions}
            isPublished={isPublished}
            goLast={goLast}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        </div>
      );
    },
    [siteAnnouncement, allAgencyOptions, isPublished, onSubmit, onCancel]
  );

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return (
    <>
      {loading && <LoadingIndicator />}
      <StepPage
        title={title}
        cancel={onCancel}
        withSidebar={false}
        spaceBetweenTopAreaAndContent={false}
      >
        <StepPage.Step renderStepContent={renderSetupStep} />
        <StepPage.Step renderStepContent={renderSummaryStep} />
      </StepPage>
    </>
  );
};
